import React from 'react';

import type {
  UserDataType,
  UserInputType,
  SetUserInputType,
  NodeConfigOptionsType
} from '../types.common';

export interface UserType {
  user: UserDataType
};

export type InputNamesType = 'firstname' | 'email' | 'password';

export interface InputNodeConfigType {
  gaPageViewName: string;
  inputTheme: string;
  name: string;
  nextButtonLabel: string;
  options?: Partial<NodeConfigOptionsType>;
  partials: InputNamesType[];
  title: string;
  type: string;
};

export interface TrackingInfo {
  flowId: string;
  flowVersion: number;
};

interface BaseInputTypes {
  emailVerificationTarget?: string;
  goToNextNode: () => void;
  setUserData: React.Dispatch<React.SetStateAction<UserDataType>>;
  setUserInput: SetUserInputType;
  trackingInfo: TrackingInfo;
  userInput: Partial<UserInputType>;
};

export interface InputNodeProps extends BaseInputTypes {
  nodeConfig: Partial<InputNodeConfigType>;
};

interface CurrentInputValueType {
  errorMessage: string;
  inputValue: string;
  isFocused: boolean;
  resetErrorMessage: () => void;
  setErrorMessage: React.Dispatch<React.SetStateAction<string>>;
  setFocus: React.Dispatch<React.SetStateAction<boolean>>;
  setInputValue: React.Dispatch<React.SetStateAction<string>>;
};

export interface CurrentInputType {
  [key: string]: CurrentInputValueType
};

export interface SubmitParamsType extends BaseInputTypes {
  currentInput: CurrentInputType;
  learnLang: string;
  nodeInputs: InputNamesType[];
  setInProgress: React.Dispatch<React.SetStateAction<boolean>>;
  flowId: string;
  invitationToken?: string;
};

export interface EmailSignupProps {
  inProgress: boolean;
  nodeConfig: Partial<InputNodeConfigType>;
  nodeInputs: InputNamesType[];
  submitParams: SubmitParamsType;
};

export interface InputProps {
  currentInput: CurrentInputValueType;
  inputName: InputNamesType;
  onEnterKeyDown?: (event: React.ChangeEvent<HTMLInputElement>) => void | Promise<void>
};

export interface TextActionButtonProps {
  value: string;
  clearInput: () => void;
};

export interface PasswordActionButtonProps {
  showPassword: boolean;
  setShowPassword: React.Dispatch<React.SetStateAction<boolean>>;
};

export type ErrorInterface = Record<InputNamesType, React.Dispatch<React.SetStateAction<string>>>;

// Define a type guard for UserType
export const isUserType = (data: UserType | boolean): data is UserType  => typeof data === 'object' && 'user' in data;
